/*
 * @Author: liyifan
 * @Date: 2025-03-12 11:06:37
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-06-24 10:14:54
 * @description product compare web-component
 * 说明在compare-content.liquid里面
 */
import './index.less'
import { getCompareGoodsList, getCompareDetail } from '@utils/fetch.js';
import { isMobile } from '@utils/index'
import { gaPushDataLayer } from '@utils/index'

$(document).ready(function () {
    if (!customElements.get('jky-compare')) {
        customElements.define('jky-compare', class jkyCompare extends HTMLElement {
            static get observedAttributes() {
                return ['type',  'isProductPage', 'currentVariantId', 'addToCartText', 'viewMore', 'pageNum'];
            }
            constructor() {
                super()
                this.variantId = this.currentVariantId
                this.productList = [] // 获取的产品集合
                this.skuIdList = [] // 选中的产品id集合
                this.selectProductList = [] // 选中的产品数据
                this.detailList = [] // 对比详情数据
                this.openDropdown = null // 判断当前下拉是打开还是关闭
                this.openDropdown
                this.DOM = {
                    loading: this.querySelector('.compare-loading'),
                    compareDetail: this.querySelector('.compare-detail'),
                    selects: this.querySelector('.selects'),
                    detailSelects: this.querySelector('.detail-selects'),
                    detailProducts: this.querySelector('.detail-products'),
                    detailInfo: this.querySelector('.detail-info'),
                }
                this.showDiff = false

                this.gaNameList = {
                    '1': 'section_compare_popup _user_clicks',
                    '2': 'section_compare_user_clicks',
                    '3': 'section_products_compare_user_clicks',
                    '4': 'section_compare_user_clicks'
                }

                // 新 main-product 触发variant变化 - 改变当前变体
                const that = this
                if (this.type == 2) {
                    if (document.querySelector('variant-fields') && this.isProductPage == 'true') {
                        document.addEventListener('variantChangeEvent', async e => {
                            const currentVariant = e.detail.variant
                            if (currentVariant) {
                                this.variantId = currentVariant.id
                                // 变体切换涉及接口请求，和产品对比详情
                                await that.updateContent();
                            }
                        })
                    }
                }
            }
            // 初始化数据
            async connectedCallback() {
                // 对比组件/弹窗
                if(this.type == '1' || this.type == '2') {
                    await this.updateContent();
                }
                // 集合页 / 通用 需要配置多个变体
                if(this.type == '3' || this.type == '4' ) {
                    // 处理变体数据
                    const ids =  JSON.parse(this.variantIds)
                    this.skuIdList = isMobile() ? ids.slice(0, 2) : ids
                    // 如果isNeedFixedFirst
                    if (this.isNeedFixedFirst == 'true') {
                        await this.getGoodsList()
                    }
                    await this.getDetail();
                }

                this.bindEvent()

            }
            // 更新内容方法
            async updateContent() {
                // 获取产品列表
                await this.getGoodsList()
                this.getDetail()
            }

            // 获取产品列表
            async getGoodsList() {
                try {
                    let params = {}
                    if (this.isNeedFixedFirst == 'true') {
                        params = {
                            pageNum: this.pageNum,
                            skuIdList: this.skuIdList,
                        }
                    } else {
                        params = {
                            pageType: this.type,
                            skuId: this.variantId
                        }
                    }

                    const { data: { classifyGoodsResps = [], skuIdList = [], pullDownFlag = 0 } } = await getCompareGoodsList(params)
                    // 代表未配置信息
                    if (classifyGoodsResps.length === 0 && skuIdList.length === 0) {
                        this.DOM.compareDetail.innerHTML = ``
                        $(this.DOM.loading).hide()
                        $(this.DOM.compareDetail).show()
                        return false
                    }
                    this.productList = classifyGoodsResps || []
                    if (this.isNeedFixedFirst !== 'true') {
                        this.skuIdList = isMobile() ? skuIdList.slice(0, 2) : skuIdList
                    }
                    this.pullDownFlag = pullDownFlag
                } catch (error) {
                } finally {
                    this.productLoading = false
                }
            }
            // 获取对比详情
            async getDetail() {
                // if (this.skuIdList.length === 0) {
                //     return false
                // }
                this.detailLoading = true
                try {
                    const params = {
                        skuIdList: isMobile() ? this.skuIdList.slice(0, 2) : this.skuIdList,
                        ...['1', '2', '3'].includes(this.type) ? {
                            pageType: this.type,
                        } : {},
                        ...['3'].includes(this.type) ? {
                            showDiff: this.showDiff
                        } : {},
                        ...['4'].includes(this.type) ? {
                            pageNum: this.pageNum
                        } : {},
                    }
                    const { data } = await getCompareDetail(params)
                    this.selectProductList = (isMobile() ? data.fourProductResps.slice(0, 2) : data.fourProductResps) || []
                    this.detailList = data.dictInfoResps || []

                    if (['1','2','3'].includes(this.type) || (['4'].includes(this.type)  && this.isNeedFixedFirst === 'true')) {
                        this.DOM.detailSelects.innerHTML = this.renderProductSelects()
                    } else {
                        this.DOM.selects.style.display = "none"
                    }
                    this.DOM.detailProducts.innerHTML = this.renderProductDetail()
                    if (['1','2','4'].includes(this.type)) {
                        this.DOM.detailInfo.innerHTML = this.renderCompareDetail()
                    } else {
                        this.DOM.detailInfo.innerHTML = this.renderDiffCompareDetail()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    this.detailLoading = false
                    $(this.DOM.loading).hide()
                    $(this.DOM.compareDetail).show()
                }
            }

            // 渲染产品下拉
            renderProductSelects() {
                if (this.selectProductList.length === 0) return ''
                const htmlParts = [];
                const arrowIcon = `<svg t="1740389594955" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2736" width="200" height="200"><path d="M512 671.288889L785.066667 398.222222l-56.888889-62.577778L512 551.822222 295.822222 335.644444 233.244444 398.222222z" fill="#000000" opacity=".5" p-id="2737"></path></svg>`;

                const productMap = new Map();
                this.productList.forEach(product => {
                    productMap.set(product.classifyTitle, product.fourProductResps);
                });

                this.selectProductList.forEach((item, index) => {
                    const { title } = item;
                    if ((index == 0 && this.isNeedFixedFirst !== 'true') || (this.type == 1 && this.pullDownFlag != 1) || this.type == 3) {
                        htmlParts.push(`
                            <div class="select-item">
                                <span class="first-label">${title}</span>
                            </div>
                        `);
                    } else {
                        const dropdownFragments = [];
                        productMap.forEach((options, classifyTitle) => {
                            const optionsHtml = options.map(opt => `
                                <div class="select-option ${item.skuId == opt.skuId ? 'selected' : ''} ${this.variantId == opt.skuId ? 'disabled' : ''}" data-classify-title="${classifyTitle}" data-title="${opt.title}" data-sku-id="${opt.skuId}" data-index="${index}">
                                    ${opt.title}
                                </div>
                            `).join('');

                            dropdownFragments.push(`
                                <div>
                                    <div class="group-label">${classifyTitle}</div>
                                    ${optionsHtml}
                                </div>
                            `);
                        });
                        htmlParts.push(`
                            <div class="select-item">
                                <div class="select-input" data-index="${index +  1}">
                                    <span class="selected-label">${title}</span>
                                    <span class="arrow">${arrowIcon}</span>
                                </div>
                                <div class="select-dropdown">
                                    ${dropdownFragments.join('')}
                                </div>
                            </div>
                        `);
                    }
                });

                // 6. 合并HTML片段
                const finalHtml = htmlParts.join('');
                return finalHtml
            }

            // 渲染产品信息
            renderProductDetail() {
                const { selectProductList, addToCartText } = this;
                if (!selectProductList.length) return '';
                const arrowSVG = `<div class="arrow">
                    <svg width="20px" height="15px" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#FFF" fill-rule="nonzero" d="M34.708 25h-3.646L37 31.026H22v2.43h15l-5.938 6.026h3.646L42 32.294z"/>
                        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="场景介绍PC" transform="translate(-694.000000, -311.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                <g id="编组-2" transform="translate(672.000000, 286.000000)">
                                    <polygon id="路径" points="34.7083333 25 31.0625 25 37 31.0256733 22 31.0256733 22 33.4570853 37 33.4570853 31.0625 39.4827586 34.7083333 39.4827586 42 32.2942361"></polygon>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>`;
                return selectProductList.map(item => `
                    <div class="product-item">
                        <div>
                            <div class="product-image" data-link="${item.goodUrl}?variant=${item.skuId}" data-title="${item.title}">
                                <a href="${item.goodUrl}?variant=${item.skuId}"
                                target="_blank}">
                                    <img src="${item.image}" alt="${item.name || 'Product Image'}">
                                </a>
                            </div>
                            ${ this.type == 4 && this.isNeedFixedFirst != 'true' ? `
                                <div class="product-title">${item.title}</div>
                            ` : ''}
                        </div>
                        <div class="product-bottom">
                            <div class="product-price">
                                <span class="price">${window.formatMoney(item.shopifyFrontprice, window.pageInfo.currency.money_format)}</span>
                                ${
                                    item.shopifyFrontOriginalPrice && item.shopifyFrontOriginalPrice > item.shopifyFrontprice ? `
                                        <span class="price-old">${window.formatMoney(item.shopifyFrontOriginalPrice, window.pageInfo.currency.money_format)}</span>` : ''
                                }
                            </div>
                            <button class="index-button add-to-cart-compare" data-sku-id="${item.skuId}" data-add-to-cart-text="${addToCartText}" data-title="${item.title}">
                                <span>${addToCartText}</span>
                                <div>${arrowSVG}</div>
                            </button>
                        </div>
                    </div>
                `).join('');
            }

            // 渲染对比详情
            renderCompareDetail() {
                let html = ''
                this.detailList.forEach((item, index) => {
                    let valHtml = ``
                    item.showValue.forEach(item1 => {
                        valHtml+=`
                            <div class="last-item">
                              <div class="key">${item.infoShowTitle}</div>
                              <div class="value">${item1 ? item1 : '一'}</div>
                            </div>
                        `
                    })
                    html += `
                        <div class="detail-item ${index > 4  && (this.type == 2 || this.type == 4) ? 'hide-more' : ''}">
                            <div class="dropdown">
                                <div class="flex-between">${valHtml}</div>
                            </div>
                        </div>
                    `
                })

                html += `
                    ${this.detailList.length > 5 && (this.type == 2 || this.type == 4) ? `
                        <div class="view-more" data-view-more="${this.viewMore}">
                            <span>${this.viewMore}</span>
                            <svg viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g transform="translate(-1002.000000, -1145.000000)">
                                        <g transform="translate(901.000000, 1142.000000)">
                                            <g transform="translate(101.000000, 3.000000)">
                                                <g transform="translate(9.000000, 9.000000) rotate(-270.000000) translate(-9.000000, -9.000000) ">
                                                    <rect x="0" y="0" width="18" height="18"></rect>
                                                    <g transform="translate(2.000000, 2.000000)" fill="#FD5000" fill-rule="nonzero">
                                                        <polygon transform="translate(9.200000, 6.905085) rotate(-90.000000) translate(-9.200000, -6.905085) " points="9.27118644 11.1050847 16.1050847 4.27118644 14.6813559 2.70508474 9.27118644 8.11525423 3.86101695 2.70508474 2.29491526 4.27118644"></polygon>
                                                        <polygon transform="translate(4.200000, 6.905085) rotate(-90.000000) translate(-4.200000, -6.905085) " points="4.27118644 11.1050847 11.1050847 4.27118644 9.68135593 2.70508474 4.27118644 8.11525423 -1.13898305 2.70508474 -2.70508474 4.27118644"></polygon>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    ` : ``}
                `

                return html
            }
            // 渲染带Show Diff 的对比详情
            renderDiffCompareDetail() {
                const getArrowIcon = () => `<svg t="1740389594955" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2736" width="200" height="200"><path d="M512 671.288889L785.066667 398.222222l-56.888889-62.577778L512 551.822222 295.822222 335.644444 233.244444 398.222222z" fill="#1a1a1a" p-id="2737"></path></svg>`;
                const renderValue = (value) => value || '一';
                const renderLastItem = (key, value, level) => `
                    <div class="last-item">
                        ${key && level > 0 ? `<div class="key">${key}</div>` : ''}
                        <div class="value">${renderValue(value)}</div>
                    </div>
                `;
                const renderFoldableSection = (title, content, levelClass = '') => `
                    <div class="${levelClass}">
                        <span class="title">${title}</span>
                        <span class="arrow">${getArrowIcon()}</span>
                    </div>
                    <div class="dropdown">${content}</div>
                `;
                const buildLevelContent = (node, level = 0) => {
                    if (!node.childInfos?.length) {
                        const items = node.showValue.map(value =>
                            renderLastItem(node.infoShowTitle, value, level)
                        ).join('');
                        return `<div class="flex-between">${items}</div>`;
                    }
                    return node.childInfos.map(child => {
                        const childContent = buildLevelContent(child, level + 1);
                        return level < 1 && child.childInfos?.length
                            ? renderFoldableSection(child.infoShowTitle, childContent, 'second-level-block')
                            : `<div>${childContent}</div>`;
                    }).join('');
                };
                return this.detailList.map(item => `
                    <div class="detail-item">
                        ${renderFoldableSection(
                            item.infoShowTitle,
                            buildLevelContent(item),
                            'first-level'
                        )}
                    </div>
                `).join('');
            }
            // 加购
            handleAddToCart(skuId, el) {
                $(el).addClass('btn--loading')
                const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                const fetchJSON = (url, config) => {
                    return fetch(url, config).then(function(response) {
                        if (!response.ok) {
                        throw response;
                        }
                        return response.json();
                    });
                }
                const config = {
                    credentials: 'same-origin',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json;'
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        items: [
                            {
                                id: skuId,
                                quantity: 1
                            }
                        ]
                    })
                }
                fetchJSON('/cart/add.js', config).then(response => {
                    if(cart && cart.renderContents) {
                        cart.renderContents(response);
                    } else {
                        window.location.href = '/cart';
                    }
                }).catch((e) => {
                    e.json().then(errorData => {
                        const message = errorData.message
                        message && pushErrorMessage(message)
                    })
                }).finally(() => {
                    $(el).removeClass('btn--loading')
                    if (cart && cart.classList.contains('is-empty')) {
                        cart.classList.remove('is-empty');
                    }
                })
            }
            // 事件绑定
            bindEvent() {
                const that = this
                // 下拉显示
                $(that).on('click', '.select-input', function() {
                    that.openDropdown = $(this).data('index') === that.openDropdown ? null : $(this).data('index')
                    if (that.openDropdown) {
                        $(this).parent().addClass('open').siblings().removeClass('open')
                    } else {
                        $(this).parent().removeClass('open')
                    }
                })

                // option 点击
                $(that).on('click', '.select-option', function() {
                    const index = Number($(this).data('index'))
                    const skuId = Number($(this).data('sku-id'))
                    const classifyTitle = $(this).data('classify-title')
                    const title = $(this).data('title')
                    that.openDropdown = null
                    if (skuId === that.skuIdList[index]) return
                    // 判断数据是否存在值
                    if (that.skuIdList.includes(skuId)) {
                        const j = that.skuIdList.findIndex(item => item === skuId)
                        const id = that.skuIdList[j]
                        that.skuIdList[j] = that.skuIdList[index]
                        that.skuIdList[index] = id
                    } else {
                        that.skuIdList[index] = skuId
                    }

                    $(that).find('.select-item.open').removeClass('open')
                    that.getDetail()
                    gaPushDataLayer(that.gaNameList[that.type], {
                        module: 'Filter',
                        title: classifyTitle,
                        position: title
                    })

                })

                // 图片点击
                $(that).on('click', '.product-image', function() {
                    const link = $(this).data('link')
                    const title = $(this).data('title')
                    gaPushDataLayer(that.gaNameList[that.type], {
                        module: 'Add to Cart',
                        link: link,
                        position: title,
                        button_name: 'picture'
                    })
                })

                // 加购
                $(that).on('click', '.add-to-cart-compare', function() {
                    const skuId = $(this).data('sku-id')
                    const title = $(this).data('title')
                    const addToCartText = $(this).data('add-to-cart-text')
                    that.handleAddToCart(skuId, this)
                    gaPushDataLayer(that.gaNameList[that.type], {
                        module: 'Add to Cart',
                        position: title,
                        button_name: addToCartText
                    })
                })

                // View More
                $(that).on('click', '.view-more', function(){
                    $(this).hide().siblings().removeClass('hide-more')
                    const text = $(this).data('view-more')
                    gaPushDataLayer(that.gaNameList[that.type], {
                        module: 'More',
                        button_name: text
                    })
                })
                // 监听checkbox点击
                if(this.type == 3) {
                    $(that).on('change', 'input[name="showDiff"]', function(){
                        that.showDiff = $(this).prop('checked')
                        that.getDetail()
                        gaPushDataLayer(that.gaNameList[that.type], {
                            module: 'Differences',
                            position: that.selectProductList.map(item =>  item.title).join(','),
                            button_name: that.addToCartText
                        })
                    })
                    // 监听点击
                    $(that).on('click', '.first-level', function() {
                        $(this).toggleClass('open').next().slideToggle('linear')
                    })
                    $(that).on('click', '.second-level-block', function() {
                        $(this).toggleClass('open').next().slideToggle('linear')
                    })
                }

                // 判断当前共有几个下拉产品
                if(this.skuIdList.length == 2 && !isMobile()) {
                    this.DOM.compareDetail.classList.add('compare-content--two')
                }
            }

            // 对比类型 1: 对比弹窗 2： 对比组件 3: 集合页 4：通用
            get type() {
                return this.getAttribute('type');
            }
            // 是否是产品页面
            get isProductPage() {
                return this.getAttribute('isProductPage');
            }

            // 当前页面的变体ID
            get currentVariantId() {
                return this.getAttribute('currentVariantId');
            }

            // 获取文本
            get addToCartText() {
                return this.getAttribute('addToCartText')
            }
            // 获取viewMore文本
            get viewMore() {
                return this.getAttribute('viewMore')
            }
            // 获取对比的ids
            get variantIds() {
                return this.getAttribute('variantIds')
            }
            // pageNum
            get pageNum() {
                return this.getAttribute('pageNum')
            }
            // 是否需要固定第一个
            get isNeedFixedFirst() {
                return this.getAttribute('isNeedFixed')
            }
        })
    }
})
